<template>
  <div v-if="visible" class="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
    <div class="bg-white rounded shadow-lg p-6">
      <h2 class="text-lg font-bold mb-4" style="white-space: pre-line;">{{message}}</h2>
	  <!-- Die Tabelle nur zeigen, wenn es wirklich Zeilen gibt - sonst stand da
	       ein leeres Geruest mit "Page 1 of 0". -->
	  <div v-if="props.items && props.items.length > 0" class="confirmtablewrapper">
		<DataTable :columns="props.colsitems" :data="props.items" :enableediting="false"/>
	  </div>
      <div class="flex justify-end gap-2">
        <button v-if="props.cancelable" @click="cancel" class="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100">
          Abbrechen
        </button>
        <button @click="confirm" class="px-3 py-1 bg-blue-500 text-white rounded">
          Bestätigen
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import DataTable from '../timintables/DataTable.vue'


const props = defineProps({
  message: {type: String, default: () => "Confirm"},
  colsitems: {type: Object, default: () => {}},
  items: { type: Array, default: () => [] },
  // Nur mit Abbrechen wird der Dialog zur Rueckfrage; ohne ist er ein Hinweis.
  cancelable: { type: Boolean, default: false }
})

const visible = ref(false)
let resolver = null

function open() {
  visible.value = true
  return new Promise((resolve) => {
    resolver = resolve
  })
}

function confirm() {
  visible.value = false
  resolver?.(true)
}

function cancel() {
  visible.value = false
  resolver?.(false)
}

defineExpose({ open })
</script>
<style>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}

th, td {
padding-left: 3px !important;
width: 50px !important;
}

.confirmtablewrapper {
	overflow-y: auto;  
}
</style>
